<template>
    <!--<v-dialog
            transition="slide-x-reverse-transition"
            @after-leave="close"
            :value="showDialog"
            v-bind="dialogOptions"
            class="sr-toolbox">-->
    <div>
        <v-slide-x-reverse-transition appear @after-leave="close">
            <div v-show="showDialog" class="v-dialog toolboxFixedRight v-dialog--active v-dialog--persistent v-dialog--scrollable" :style="{width: getWidth + 'px'}" :key="item.id">
                <component :is="getToolboxComponent"
                           v-bind="layoutOptions"
                           :item="item"
                           @close="startCloseTransition"
                           @save="save"
                           :loading="loading"
                           @loading="loading = $event"
                           ref="layout"></component>
            </div>
        </v-slide-x-reverse-transition>
    </div>
    <!-- </v-dialog> -->
</template>

<script>
  import DefaultLayout from './GisLayout'
  import { VDialog } from 'vuetify/lib'

  export default {
    components: {
      VDialog
    },
    props: {
      dialogOptions: {
        type: Object,
        required: true
      },
      layoutOptions: {
        type: Object
      },
      item: {
        type: Object,
        required: true
      },
      onConfirm: {
        type: Function
      },
      onConfirmError: {
        type: Function
      },
      closeOnError: {
        type: Boolean,
        default: false
      },
      toolbox: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        showDialog: false,
        loading: false,
        result: {
          confirmed: false,
          content: null,
          onConfirm: null
        }
      }
    },
    created () {
      this._loadedComponents = {}
      for (let key in this.$options.components) {
        this._loadedComponents[key] = key
      }
    },
    methods: {
      show () {
        this.showDialog = true
      },
      hide () {
        this.showDialog = false
      },
      startCloseTransition () {
        this.hide()
        // thanks vuetify ;)
        // setTimeout(() => this.close(), 400)
      },
      close () {
        this.result.content = this.toolbox.contentData
        this.toolbox.close()
      },
      async save () {
        this.result.confirmed = true
        if (this.onConfirm) {
          this.loading = true
          let result
          try {
            result = await this.onConfirm(this.toolbox)
          } catch (e) {
            if (this.onConfirmError) {
              await this.onConfirmError(this.toolbox, e)
            }

            this.loading = false
            this.result.confirmed = false
            if (!this.closeOnError) {
              return
            }
          }

          this.result.onConfirm = result
          this.loading = false
        }
        this.result.content = this.toolbox.contentData

        this.startCloseTransition()
      }
    },
    computed: {
      getToolboxComponent () {
        if (typeof this._loadedComponents[this.item.constructor.name + 'Toolbox'] !== 'undefined') {
          return this.item.constructor.name + 'Toolbox'
        }

        return DefaultLayout
      },
      getWidth () {
        return this.dialogOptions.width || '400'
      }
    }
  }
</script>

<style>
    .toolboxFixedRight {
        position: fixed;
        right: 0;
        top: 75px;
        width: 350px;
        height: 100%;
        margin: 0;
        max-height: calc(100% - 75px) !important;
    }
</style>
